/** Last known good applies to jnet2 CAP and Node devices only. */
export function isLastKnownGoodEligible(device) {
  if (!device) return false;
  const caps = device.capabilities || device;
  const compatible = String(caps.compatible || device.compatible || '').toLowerCase();
  if (compatible !== 'jnet2') return false;
  const model = String(caps.model || '').toLowerCase();
  if (model.includes('cap')) return true;
  return model.includes('node');
}

export function filterLastKnownGoodEligible(devices) {
  if (!Array.isArray(devices)) return [];
  return devices.filter(isLastKnownGoodEligible);
}

export const LKG_INELIGIBLE_MSG = 'Last known good is only supported for jnet2 CAP and Node devices.';
